


export const Validator = {

    onlyLetters : function (value){
        return /^[a-zA-Z\s]+$/.test(value) || /^[A-Za-zΑ-Ωα-ωίϊΐόάέύϋΰήώΆΈΊΌΎΏΉ\s$]+$/.test(value);
    },

    onlyNumbers: function (value) {
        return $.isNumeric(value) || (!this.isEmpty(value) && /^[0-9]*$/g.test(value));
    },

    validateEmail(email) {
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    
    containSpecialChars: function (value) {
        return /[()_+\=\[\]{};':"\\|<>\/?=~]+/.test(value);
    },

    containPasswordAllowedSpecialChars: function (value) {
        return /[!@#$%&]+/.test(value);
    },

    stripTags: function (value) {
        if($.isNumeric(value)) return value;
        return value.replace(/(<([^>]+)>)/ig,"");
    },

    isAllowedFormat: function (file){
        let isAllowed = false;
        let allowedFormats = ["DOC","DOCX","PDF",'JPEG','JPG','PNG'];

        let fileParts = file.split(".");

        var check = fileParts[1];

        allowedFormats.forEach( p => {
            if (p === check.toUpperCase())
            {
                isAllowed = true;
            }
        });
        return isAllowed;
    },

    isEmpty: function (value) {
        return !value || (value.trim()).length === 0;
    },
    
    isEmptyObject: function(obj){
        return typeof obj === 'object' && obj != null && Object.keys(obj).length === 0;
    },

    amValidation: function (am) {
        // check if am contains exactly 11 digits
        return (/^\d+$/.test(am) && am.length === 11);
    },

    afmDigitsValidation: function (afm) {
        return (/^\d+$/.test(afm) && afm.length === 9);
    },

    afmValidation: function (afm) {
        const sequence = afm.substring(0, 8);
        let sum = 0;

        for(let i = 0; i < 8; i++) {
            sum += parseInt(sequence[i]) << (8 - i);
        }

        const calc = sum % 11;
        const d9 = parseInt(afm[8]);
        const valid = calc % 10 === d9;

        return valid
    }
}

